/* eslint react/forbid-prop-types: 0 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {HeroImage} from './HeroImage';
import {SearchBoxLite} from '../../common/searchboxlite/SearchBoxLite';

export function mapStateToProps(state) {
    return {
        details: state.destination.details,
        hasListings: state.destination.listings.length > 0,
        jumbotron: state.modules.jumbotron
    };
}

export class HeaderComponent extends Component {
    static propTypes = {
        details: PropTypes.shape({
            fullName: PropTypes.string
        }),
        hasListings: PropTypes.bool,
        jumbotron: PropTypes.shape({
            heading: PropTypes.string,
            subheading: PropTypes.string,
            heroImage: PropTypes.shape({
                urlTemplate: PropTypes.string,
                defaultImage: PropTypes.string,
            })
        })
    };

    render() {
        const {
            details,
            hasListings,
            jumbotron: {heading, subheading, heroImage}
        } = this.props;

        return (
            <div className="expanded-searchbox">
                <div className="ha-header">
                    <HeroImage
                        urlTemplate={heroImage.urlTemplate}
                        defaultImage={heroImage.defaultImage}
                        altText={details.fullName}
                    />
                    <div className="jumbotron">
                        <div className="heading">
                            <div className="main-heading">
                                <h1>{heading}</h1>
                            </div>
                            {(subheading && hasListings) && (
                                <h2>
                                    {subheading}
                                </h2>
                            )}
                        </div>
                        <div className="searchbox-root">
                            <SearchBoxLite />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const Header = connect(mapStateToProps)(HeaderComponent);
